export default [
    {
        path: "/admin/facturapormail/facturas",
        name: "admin.fpm.facturas.listar",
        component: () =>
            import(
                /* webpackChunkName: "fpm.private"*/
                "./vue-components/facturas-list.vue"
            ),
    },
];
